import { Button } from '@mui/material';
import { useCallback, useRef } from 'react';

type Props = {
  accept: string;
  onUploaded: (file: File) => void;
  label: string;
  disabled?: boolean;
};

export const FileUploadButton = ({ accept, label, onUploaded, disabled = false }: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const changeHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = e.currentTarget;
      if (files?.[0]) onUploaded(files[0]);
    },
    [onUploaded],
  );

  return (
    <>
      <input
        onChange={changeHandler}
        accept={accept}
        ref={fileInputRef}
        type='file'
        style={{ display: 'none' }}
      />
      <Button
        disabled={disabled}
        onClick={() => {
          if (fileInputRef.current) fileInputRef.current.click();
        }}
      >
        {label}
      </Button>
    </>
  );
};
